// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack } from '@mantine/core';

import { MobileBasePageHeader } from 'components/Mantine/MobileBasePageHeader';
import { useWorkOrderDetailMutations } from 'modules/Shop/WorkOrders/WorkOrderDetail/useWorkOrderDetailMutations';
import type { WorkOrderDetailPageProps } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderDetailPage';
import { WorkOrderDetailSidePane } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderDetailSidePane';

/** The `/details` sub-page of the mobile Work Order detail page — renders the detail side pane full-width. */
export const MobileWorkOrderDetailsView = ({ workOrder, onWorkOrderUpdated }: WorkOrderDetailPageProps) => {
  const detailMutations = useWorkOrderDetailMutations(workOrder, onWorkOrderUpdated);

  return (
    <Stack flex={1} mih={0} w="100%" p="md" pb={0} gap="xs">
      <MobileBasePageHeader
        title={workOrder.identifier}
        parentPage={{ title: workOrder.identifier, url: `/work-orders/${workOrder.workOrderId}` }}
        hideGlobalFilters
      />
      <Stack flex={1} style={{ overflowY: 'auto' }} gap="md">
        <WorkOrderDetailSidePane {...detailMutations} />
      </Stack>
    </Stack>
  );
};
